import React from "react";
import Divider from "@material-ui/core/Divider";
import { Link } from "react-router-dom";

export default function DoctorsList() {
  return (
    <>
      <h2 data-toggle="collapse" data-target="#doc" className="navhead">
        Doctor
      </h2>
      <Divider />
      <div class="collapse indent" id="doc">
        {/* Videos */}
        <Link className="video" to="/DoctorVideo">
          <h3 data-toggle="collapse">Videos</h3>
        </Link>
        <Divider />
        {/* Patient MGMT */}
        <h3 data-toggle="collapse" data-target="#doc1">
          Patient Management
        </h3>
        <Divider />
        <ul id="doc1" class="collapse">
        <Link to="/MergePatient">
            <li>Merge Patient</li>
          </Link>
          <Link to="/AssignDoctor">
            <li>Assign Doctor</li>
          </Link>
          <Link to="/AddReferraltoPatient">
            <li>Add Referral</li>
          </Link>
          <Link to="/AddPatientFiles">
            <li>Add Patient Files</li>
          </Link>
          <Link to="/AddGeneralNotes">
            <li>Add General Notes</li>
          </Link>
          <Link to="/Prescription">
            <li>Add Prescriptions</li>
          </Link>
          <Link to="/ViewPatientForms">
            <li>View Patient Forms</li>
          </Link>
          <Link to="/ViewAddress">
            <li>View Address</li>
          </Link>
          <Link to="/ViewAddClinicNts">
            <li>Clinical Notes</li>
          </Link>
          <Link to="/ScanDocs">
            <li>Scan Documents</li>
          </Link>
          <Link to="/RequestXRay">
            <li>Request X-Ray</li>
          </Link>
          <Link to="/WaitingReview">
            <li>Waiting Review</li>
          </Link>
          <Link to="/Discharge">
            <li>Discharge</li>
          </Link>
        </ul>
        {/* Calendar */}
        <h3 data-toggle="collapse" data-target="#doc2">
          Calendar
        </h3>
        <Divider />
        <ul id="doc2" class="collapse">
          <Link to="/ViewAllAppointments">
            <li>View All Appointments</li>
          </Link>
          <Link to="/ViewDocAppointments">
            <li>View Other Doctors Appointments</li>
          </Link>
        </ul>
        {/* Misc */}
        <h3 data-toggle="collapse" data-target="#doc3">
          Misc
        </h3>
        <Divider />
        <ul id="doc3" class="collapse">
          <Link to="/ViewDashboard">
            <li>View Dashboards</li>
          </Link>
          <Link to="/SearchPatients">
            <li>Search Patients</li>
          </Link>
          <Link to="/ViewPolicies">
            <li>View Policies and procedures</li>
          </Link>
        </ul>
      </div>
    </>
  );
}
